import DynamicFAQ from './DynamicFAQ'

export default DynamicFAQ
